import React, { useEffect, useState } from "react";

export default function TextPargraph({text,minlength,style={size:'normal'}})
{
    const[displayAll,setDisplayAll] = useState(false);
    const [displayedText,setDisplayedText] = useState(text);
    const [buttonText,setButtonText] = useState("  afficher plus ...")

    useEffect(()=>{
        if(displayAll)
        {
            setDisplayedText(text);
            setButtonText("afficher moins ...");
        }
        else
        {
            if(!!text && text.length>minlength)
            {
                setDisplayedText(text.substring(0,minlength));
                setButtonText("afficher plus ... ");
            }
            else
            {
                setButtonText("");
                setDisplayedText(text);
            }
        }
    },[displayAll, text]);

    return (
        <div>
            <p style={{fontSize:style.size}}>{displayedText}<span onClick={(e)=>{setDisplayAll(!displayAll);}} style={{color:"blue",marginLeft:"10px"}}>{buttonText}</span></p>
        </div>
    );
}